import React from "react";
import DateRangePicker from "react-bootstrap-daterangepicker";
import moment from "moment";

export default function RsDateRangePicker(props) {
  // console.log(
  //   props?.showDate?.startDate,
  //   moment(new Date(props?.showDate?.startDate)).format("MM/DD/YYYY")
  // );

  let filterDate = {};

  if (props?.showDate) {
    filterDate = {
      startDate: moment(new Date(props?.showDate?.startDate))
        .add(1, "hour")
        .format("MM/DD/YYYY"),
      endDate: moment(new Date(props?.showDate?.endDate))
        .add(1, "hour")
        .format("MM/DD/YYYY"),
    };
  }

  return (
    <DateRangePicker
      initialSettings={{
        //autoUpdateInput: false,
        ...filterDate,
        locale: {
          cancelLabel: "Clear",
        },
      }}
      {...props}
      onApply={props.onOk}
      onCancel={props.onClean}
    >
      <input
        type="text"
        className="form-control bg-white"
        defaultValue=""
        placeholder={
          props?.placeholder ? props?.placeholder : "dd/mm/yyyy - dd/mm/yyyy"
        }
        readOnly
      />
    </DateRangePicker>
  );
}
